<template>
  <modal-lightbox v-if="showLogin" @close="close">
    <div v-if="busy" class="fullscreen-centered">Logging In...</div>
    <div v-bind:class="{ invisible: busy }">
      <div>
        <p class="center">
          <slot name="title">Login</slot>
        </p>
        <p class="center subtext">
          <slot name="description">Please enter your Working Platform login and password to continue</slot>
        </p>
      </div>
      <div class="flex flex-column">
        <div class="flex-auto flex flex-column justify-center">
          <div class="center">
            <form autocomplete="off" @submit.prevent>
              <div v-if="error" class="my3 error">
                <span class="p6">
                  {{ error }}
                </span>
              </div>

              <div class="my3">
                <label for="username" class="label block col-12 h6 left-align">USERNAME</label>
                <input v-model="login.username" id="username" class="input p1 col-12" autocomplete="username">
              </div>

              <div class="mb3">
                <label for="password" class="label block col-12 h6 left-align">PASSWORD</label>
                <input type="password" v-model="login.password" id="password" class="input p1 col-12" autocomplete="current-password">
              </div>

              <div class="h6">
                <button @click="tryLoginRedirect" class="btn btn-rounded white bg-black col-12">LOGIN</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal-lightbox>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'ModalLogin',
    data () {
      return {
        busy: false,
        login: {
          username: null,
          password: null
        },
        error: null
      }
    },
    computed: {
      showLogin: {
        get () {
          return this.$store.state.showLogin
        },
        set (newVal) {
          this.$store.commit('SET_LOGIN_VIS', newVal)
        }
      }
    },
    methods: {
      close () {
        this.showLogin = false
      },
      async tryLoginRedirect () {
        this.$store.dispatch('startLoginFlow')
      },
      async tryLoginModal () {
        this.busy = true;
        try {
          const result = await store.dispatch('login', {
            username: this.login.username,
            password: this.login.password
          })

          if (result === true) {
            this.$emit('close')
            this.$emit('success')
          } else  {
            this.error = result.error
          }
          this.busy = false
        } catch (error) {
          this.busy = false
          throw error
        }
      }
    }
  }
</script>

<style scoped>
.error {
  color: red;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  letter-spacing: 0.0918403px;
  padding: 0 20px;
  text-align: left;
  padding: 0;
}

.invisible {
  visibility: hidden;
}
</style>
